import React from 'react';




const NavMiddlle = () => {
    return (
        <div className='block pt-12 md:pb-2 my-2 md:my-0 h-auto  min-w-[400px] md:w-[900px] mx-auto '>
            <img className='block bg-cover no-repeat' src={require("./Add.png")} alt='logo'/>
        </div>
        );
}

export default NavMiddlle;